import { Component, ElementRef, OnInit, Renderer2, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from '@teem/services/dashboard.service';
import { RejectionReasonComponent } from '@teem/features/dashboard/modals/rejection-reason/rejection-reason.component';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
import { LoaderService } from '@teem/core/services/loader.service';
@Component({
	selector: 'app-current-orders-table',
	templateUrl: './current-orders.component.html',
	styleUrls: ['./current-orders.component.scss']
})
export class CurrentOrdersComponent implements OnInit {
	@Output() orderAction: EventEmitter<any> = new EventEmitter();
	filterTypeCurrentOrders: string = 'all';
	isMenuUpwards = false;
	params: any = {};
	order_status: any = '';
	selectedText: string = i18n.dashboard.select_an_option;
	selectAllFilteredOrders: boolean = false;
	activeDropdown: HTMLElement | null = null;
	currentOrders: any = [];

	fromDate: string = '';
	toDate: string = '';
	selectedOrderType: string = 'all';
	fromAmount: number | null = null;
	toAmount: number | null = null;
	selectedUuids: string[] = [];
	filteredCurrentOrders: any[] = [...this.currentOrders];

	constructor(
		private loaderService:LoaderService,
		private modalService: NgbModal,
		private renderer: Renderer2,
		private el: ElementRef,
		private dashboardService: DashboardService,
		private cdr: ChangeDetectorRef,
	) {
		document.addEventListener('click', (event: Event) => {
			this.currentOrders.forEach((r) => (r.menuVisible = false));

			const targetElement = event.target as HTMLElement;

			if (!targetElement.closest('.dots_container-rounded')) {
				this.currentOrders.forEach((r) => (r.menuVisible = false));

				const optionsMenus = this.el.nativeElement.querySelectorAll('.options-menu');
				optionsMenus.forEach((menu: HTMLElement) => {
					this.renderer.addClass(menu, 'd-none');
				});
			}
		});
	}

	ngOnInit(): void {
		this.getCurrentOrders();
	}

	onDateChange() {

		console.log('current')
		if (this.fromDate && this.toDate) {
			this.getCurrentOrders();
		}
	}

	onAmountChange() {
		if (this.fromAmount !== null && this.toAmount !== null && this.fromAmount <= this.toAmount) {
			this.getCurrentOrders();
		}
	}


	public getCurrentOrders() {
		this.currentOrders = [];
		this.filteredCurrentOrders = [];
		this.loaderService.startLoading();
		const payload = {
			from_date: this.fromDate,
			to_date: this.toDate,
			min_amount: this.fromAmount,
			max_amount: this.toAmount,
			order_status: this.order_status
		};
		this.dashboardService.getCurrentOrders(payload).subscribe((response: any = []) => {
			this.currentOrders = response;
			this.filteredCurrentOrders = [...this.currentOrders];
			this.setFilter(this.filterTypeCurrentOrders);
			this.cdr.detectChanges();
			this.loaderService.stopLoading();
		});
		
	}

	toggleMenu(event: MouseEvent, row: any, index: number): void {
		event.stopPropagation();

		// Hide other menus first
		this.currentOrders.forEach((r, i) => {
			if (i !== index) {
				r.menuVisible = false;
			}
		});

		const totalRows = this.currentOrders.length;
		// decide whether menu should open upwards based on row index
		this.isMenuUpwards = index >= totalRows - 2;

		// Toggle this row's menu visibility
		row.menuVisible = !row.menuVisible;

		// If the menu was opened, ensure the row (and the menu) is visible inside the scrollable container.
		if (row.menuVisible) {
			setTimeout(() => {
				const rowElement = (event.target as HTMLElement).closest('tr') as HTMLElement | null;
				const scrollContainer = this.el.nativeElement.querySelector('.order_history_table') as HTMLElement | null;
				const optionsMenu = rowElement ? rowElement.querySelector('.options-menu') as HTMLElement | null : null;
				const menuHeight = optionsMenu ? optionsMenu.offsetHeight : 160; 
				const margin = 116; 

				if (rowElement && scrollContainer) {
					const containerRect = scrollContainer.getBoundingClientRect();
					const rowRect = rowElement.getBoundingClientRect();

					if (this.isMenuUpwards) {
						// need enough space above the row for the menu
						const availableAbove = rowRect.top - containerRect.top;
						if (availableAbove < menuHeight + margin) {
							const delta = (menuHeight + margin) - availableAbove;
							// scroll up (decrease scrollTop)
							scrollContainer.scrollTo({ top: Math.max(0, scrollContainer.scrollTop - delta), behavior: 'smooth' });
						}
					} else {
						// need enough space below the row for the menu
						const availableBelow = containerRect.bottom - rowRect.bottom;
						if (availableBelow < menuHeight + margin) {
							const delta = (menuHeight + margin) - availableBelow;
							// scroll down (increase scrollTop)
							scrollContainer.scrollTo({ top: scrollContainer.scrollTop + delta, behavior: 'smooth' });
						}
					}
				} else if (rowElement) {
					// fallback: bring row into view centered
					rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}
			}, 0);
		}
	}

	get selectedCurrentOrdersCount(): number {
		return this.currentOrders.filter(order => order.selected).length;
	}

	setFilter(type: string) {
	this.filterTypeCurrentOrders = type;

	if (type === 'all') {
		this.filteredCurrentOrders = this.currentOrders;
	} else {
		const isPickup = type === 'pick-up';
		this.filteredCurrentOrders = this.currentOrders.filter(order =>
			isPickup ? !!order.pickup_date : !order.pickup_date
		);
	}
}

	toggleAllSelections(invoices: any[], selectAllVar: string) {
		this[selectAllVar] = !this[selectAllVar];
		invoices.forEach((invoice) => { 
			invoice.selected = this[selectAllVar]
			if (this[selectAllVar]) {
				this.selectedUuids.push(invoice.uuid);  // Add UUID if checked
			} else {
				const index = this.selectedUuids.indexOf(invoice.uuid);
				if (index !== -1) {
					this.selectedUuids.splice(index, 1);  // Remove UUID if unchecked
				}
			}
		});
	}

	toggleSelection(invoices: any[], selectAllVar: string) {
		this[selectAllVar] = invoices.every(invoice => invoice.selected);
	}

	toggleFilters(event: Event): void {
		const selectedElement = event.target as HTMLElement;
		console.log('selectedElement', selectedElement)
		const filterElementFather = selectedElement.closest('.order_history_block');
		const filterElement = filterElementFather.querySelector('.filters_expanded');
		console.log('filterElementFather', filterElementFather)
		console.log('filterElement', filterElement)

		if (filterElement) {
			if (filterElement.classList.contains('visible')) {
				this.renderer.removeClass(filterElement, 'visible');
			} else {
				this.renderer.addClass(filterElement, 'visible');
			}
		}
	}

	clearAllFilter() {
		this.fromDate = '';
		this.toDate = '';
		this.fromAmount = null;
		this.toAmount = null;
		this.order_status = '';
		this.selectedText = 'Select an option';
		this.getCurrentOrders();
	}

	selectItem(event: Event): void {
		const selectedElement = event.target as HTMLElement;
		this.selectedText = selectedElement.innerText.trim();
		this.order_status = this.selectedText;
		const activeDropdowns = document.querySelectorAll('.custom_select.active');
		activeDropdowns.forEach((dropdown) => {
			this.renderer.removeClass(dropdown, 'active');
			const dropdownMenu = dropdown.querySelector('.custom_select-content') as HTMLElement;
			if (dropdownMenu) {
				this.renderer.setStyle(dropdownMenu, 'display', 'none');
			}
		});

		this.activeDropdown = null;
		this.getCurrentOrders();
	}

	trackByInvoice(index: number, order: any) {
		return order.invoiceNum;
	}

	toggleDropdown(event: Event): void {
		const button = event.target as HTMLElement;
		const dropdownContainer = button.closest('.custom_select');
		const dropdownMenu = dropdownContainer.querySelector('.custom_select-content');
		const allDropdowns = document.querySelectorAll('.custom_select-content');
		const allContainers = document.querySelectorAll('.custom_select');

		allDropdowns.forEach((dropdown) => {
			if (dropdown !== dropdownMenu) {
				this.renderer.setStyle(dropdown, 'display', 'none');
			}
		});

		allContainers.forEach((container) => {
			if (container !== dropdownContainer) {
				this.renderer.removeClass(container, 'active');
			}
		});

		const isDropdownVisible = dropdownMenu.getAttribute('style') === 'display: block;';

		this.renderer.setStyle(dropdownMenu, 'display', isDropdownVisible ? 'none' : 'block');

		if (isDropdownVisible) {
			this.renderer.removeClass(dropdownContainer, 'active');
		} else {
			this.renderer.addClass(dropdownContainer, 'active');
		}
	}

	orderActions(action, uuid) {
		switch (action) {
			case "resend_invoice":
				this.orderAction.emit({ uuid: uuid, action: action });
				break;
			case "accept":
				Swal.fire({
					title: i18n.are_you_sure_want_accept_order,
					icon: 'info',
					showCloseButton: true,
					showCancelButton: true,
					focusConfirm: false,
					confirmButtonColor: '#ee3a7a',
					confirmButtonText: i18n.accept_order,
					cancelButtonText: i18n.cancel
				}).then(result => {
					console.log(result);
					if (result.value) {
						this.orderAction.emit({ uuid: uuid, action: action });
					}
				});
				break;
			case "cancel":
				Swal.fire({
					title: i18n.order.are_you_sure_want_cancel_order,
					showCloseButton: true,
					showCancelButton: true,
					focusConfirm: false,
					confirmButtonColor: '#ee3a7a',
					confirmButtonText: i18n.order.cancel_order,
					cancelButtonText: i18n.cancel
				}).then(result => {
					if (result.value) {
						this.orderAction.emit({ uuid: uuid, action: action });
					}
				});
				break;
		  	case "rejected":
				const modalRef = this.modalService.open(RejectionReasonComponent);
				console.log(modalRef.componentInstance)
				modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "rejection-modal";
				modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.classList.add("quotation-modal");
				modalRef.componentInstance.orderAction = this.orderAction;
				modalRef.componentInstance.orderStatus = 'rejected';
				modalRef.componentInstance.orderUuid = uuid;
				modalRef.result.then(data => {
		
				}, fallbackResult => {
		
				})
				break;
			case "accept_selected":
				Swal.fire({
					title: i18n.are_you_sure_want_accept_order,
					icon: 'info',
					showCloseButton: true,
					showCancelButton: true,
					focusConfirm: false,
					confirmButtonColor: '#ee3a7a',
					confirmButtonText: i18n.accept_order,
					cancelButtonText: i18n.cancel
				}).then(result => {
					if (result.value) {
						this.orderAction.emit({ uuid: this.selectedUuids, action: action });
					}
				});
				break;
		}
	}

	capitalizeFirstLetter(str) {
		if (!str) return str;  // Check for empty or null strings
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	onCheckboxChange(event: any, uuid: string) {
		if (event.target.checked) {
			this.selectedUuids.push(uuid);  // Add UUID if checked
		} else {
			const index = this.selectedUuids.indexOf(uuid);
			if (index !== -1) {
				this.selectedUuids.splice(index, 1);  // Remove UUID if unchecked
			}
		}
	}

	transStatus(status : string) {
		return i18n.t(status.toLowerCase());
	}
}
